import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { RootState } from 'redux/store'
import { createSelector } from 'reselect'
import { isEmpty } from 'lodash'

type Message = string

interface AuthenticationState {
    message: Message
}

export const initialState: AuthenticationState = {
    message: '',
}

const authenticationSlice = createSlice({
    name: 'authentication',
    initialState: initialState,
    reducers: {
        setErrorMessage: (state, action: PayloadAction<Message>) => {
            state.message = action.payload
        },
    },
})

const { actions, reducer } = authenticationSlice
export default reducer

export const getAuthentication = (store: RootState) => store.authentication
export const getErrorMessage = createSelector(getAuthentication, auth => auth.message)
export const shouldShowAuthError = createSelector(getAuthentication, auth => !isEmpty(auth.message))

export const { setErrorMessage } = actions
